import { graphql } from "./generated/index.js"

// Changesets (`record_changesets`): the unit undo reverts. A revert is another
// changeset; undo_changeset (postgres/functions/undo_changeset.sql) applies it
// and returns that changeset's row. The per-table rules are in
// postgres/docs/CHANGESETS.md.

// Apply the revert. The row is the changeset the revert opened: `context` has
// what landed (`reverted`), what was refused (`skipped`) and the first skipped
// units with their reasons (`skipped_units`). No row comes back when nothing
// needed undoing.
export const undoChangeset = graphql(`
  mutation undoChangeset($changesetId: Int!) {
    undo_changeset(args: { p_changeset_id: $changesetId }) {
      id
      reverts_changeset_id
      label
      context
      created_at
    }
  }
`)

// How much a changeset touched: its rows, and the distinct records they name.
// An upper bound on a revert, which nets out edits that cancel and skips rows
// that changed since. Counts only the records the viewer can see.
export const fetchChangesetImpact = graphql(`
  query fetchChangesetImpact($changesetId: Int!) {
    record_changes_aggregate(where: { changeset_id: { _eq: $changesetId } }) {
      aggregate {
        changes: count
        records: count(columns: record_id, distinct: true)
      }
    }
  }
`)
